import {TOGGLE_MODAL} from '../actions/constant';

const initialState = {};

export default function modals(state = initialState, action = {}) {
  const {type, payload} = action;
  if (type === TOGGLE_MODAL) {
    return {
      ...state,
      [payload.modal]: payload.isOpen
    };
  }

  return state;
}
